export default function FiltersSidebar({ filters, selected, onChange }) {
  if (!filters || Object.keys(filters).length === 0) return null;

  return (
    <aside className="bg-white rounded-2xl shadow p-4 space-y-6">
      {Object.entries(filters).map(([key, values]) => (
        <div key={key}>
          <h3 className="font-semibold mb-2">{key}</h3>

          {values.map((v) => (
            <label key={v} className="flex items-center gap-2 text-sm">
              <input
                type="checkbox"
                checked={selected[key] === v}
                onChange={() =>
                  onChange(key, selected[key] === v ? "" : v)
                }
              />
              {v}
            </label>
          ))}
        </div>
      ))}
    </aside>
  );
}
